import { app } from '../../../../app';
import { Controller } from './computers-report.controller';

app.component('companyComputersReport', {
    bindings: {
        companyId: '<',
        computersProtectionApplications: '<',
    },
    controller: Controller,
    templateUrl: require('./computers-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/computers-report/computers-report.component.js